<main
  class="sn:ml-12"
  [ngClass]="{
    'main-container-open-sidenav':
      sideNavigationService.isSideNavOpen() &&
      !platformService.isMobile() &&
      !currentNavigationItemService.currentNavigationItem().hideSideNavigation,
  }"
>
  <ng-content></ng-content>
</main>
